export const ANYBODY_VALUE = 'ANYONE_VALUE';
export const ANYBODY_LABEL = 'Anybody';
export const ANYBODY_OPTION = {
  value: ANYBODY_VALUE,
  label: ANYBODY_LABEL,
} as const;
